import React from 'react';
import { cn } from '../../../../utils/tailwind';

type OnboardingFooterType = {
    children: React.ReactNode | React.ReactNode[];
    direction?: 'row' | 'column';
};

export const OnboardingFooter: React.FC<OnboardingFooterType> = ({ children, direction = 'row' }) => {
    return (
        <div
            className={cn(
                'mt-medium flex justify-between gap-small sm:flex-col sm:items-stretch sm:[&_button]:w-full',
                direction === 'column' ? 'flex-col' : 'flex-row',
            )}
        >
            {children}
        </div>
    );
};
